import { render } from "./LogHistogramWidget.vue?vue&type=template&id=186592d9&scoped=true"
import script from "./LogHistogramWidget.vue?vue&type=script&lang=js"
export * from "./LogHistogramWidget.vue?vue&type=script&lang=js"

import "./LogHistogramWidget.vue?vue&type=style&index=0&id=186592d9&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186592d9"]])

export default __exports__